import * as z from 'zod';
import { ReservableProductResource } from './ReservableProduct';
import { LocalizedString, Tag } from '../base-schemas';
export const ReservableProductCategoryResource = z.object({
    _tag: Tag('ReservableProductCategoryResource'),
    id: z.number(),
    title: LocalizedString,
    slug: z.string(),
    order: z.number(),
    reservable_products: z.array(ReservableProductResource)
});
